var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.140657 0.834226C-0.0468858 0.64673 -0.0468858 0.334674 0.140657 0.140622C0.334758 -0.046874 0.640335 -0.046874 0.834435 0.140622L4.99754 4.30967L9.16764 0.140622C9.35518 -0.046874 9.66732 -0.046874 9.85442 0.140622C10.0485 0.334674 10.0485 0.647167 9.85442 0.834226L5.69132 4.99672L9.85442 9.16577C10.0485 9.35327 10.0485 9.66533 9.85442 9.85938C9.66688 10.0469 9.35475 10.0469 9.16764 9.85938L4.99754 5.69033L0.834435 9.85938C0.640335 10.0469 0.334758 10.0469 0.140657 9.85938C-0.0468858 9.66533 -0.0468858 9.35283 0.140657 9.16577L4.30376 4.99672L0.140657 0.834226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ea02de25805c6a06ac035d7cfc50a7e9.svg";
export { ForwardRef as ReactComponent };